<template>
  <div class="container">
    <div
      style="display: flex; align-items: center; gap: 16px; margin-bottom: 16px"
    >
      <a-form layout="inline">
        <a-form-item>
          <div class="form-item-content">
            <div class="label">搜索内容：</div>
            <a-input
              placeholder="备注/快递单号"
              v-model:value="listRequest.content"
            />
          </div>
        </a-form-item>
        <a-form-item>
          <div class="form-item-content">
            <div class="label">运输状态：</div>
            <a-select style="width: 200px" v-model:value="listRequest.status">
              <a-select-option :value="1">待寄出</a-select-option>
              <a-select-option :value="2">运输中</a-select-option>
              <a-select-option :value="3">已完成</a-select-option>
            </a-select>
          </div>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="handleList">搜索</a-button>
          <a-button style="margin-left: 10px" @click="resetSearch"
            >重置
          </a-button>
        </a-form-item>
      </a-form>
    </div>
    <a-table
      :columns="columns"
      :data-source="replyList"
      :pagination="{
        current: listRequest.current,
        pageSize: listRequest.size,
        total: total,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 30, 40, 50],
        onChange: handleChange,
        onShowSizeChange: handleSizeChange,
      }"
      bordered
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'update_at'">
          <span
            >{{ dayjs(record.update_at).format("YYYY-MM-DD HH:mm:ss") }}
          </span>
        </template>
        <template v-if="column.dataIndex === 'status'">
          <a-tag v-if="record.status === 1" color="yellow">待寄出</a-tag>
          <a-tag v-if="record.status === 2" color="green">运输中</a-tag>
          <a-tag v-if="record.status === 3" color="red">已完成</a-tag>
        </template>
        <template v-else-if="column.dataIndex === 'is_delete'">
          <a-tag v-if="record.is_delete === 1" color="green">正常</a-tag>
          <a-tag v-if="record.is_delete === 2" color="red">回收站</a-tag>
        </template>
        <template v-else-if="column.dataIndex === 'create_at'">
          <span
            >{{ dayjs(record.create_at).format("YYYY-MM-DD HH:mm:ss") }}
          </span>
        </template>
        <template v-else-if="column.dataIndex === 'operator'">
          <a-button
            @click="submitDelete(record)"
            type="primary"
            :style="{
              backgroundColor: '#ff7a45',
              color: 'white',
              marginRight: '8px',
            }"
            >删除
          </a-button>
          <a-button
            @click="submitDrop(record)"
            type="primary"
            :style="{
              backgroundColor: '#ff4d4f',
              color: 'white',
            }"
            >彻底删除
          </a-button>
        </template>
      </template>
    </a-table>
  </div>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from "vue";
import { message } from "ant-design-vue";
import dayjs from "dayjs";
import { ColumnType } from "ant-design-vue/lib/table";
import { RechargeOrder } from "@/api/models/recharge_order/RechargeOrder";
import { ReplyService } from "@/api/services/ReplyService";
import { ReplyListRequest } from "@/api/models/reply/ReplyListRequest";
import { Reply } from "@/api/models/reply/Reply";

const total = ref<number>(0);

const listRequest = reactive<ReplyListRequest>({
  current: 1,
  size: 20,
});

const replyList = ref<Reply[]>([]);

const handleList = async () => {
  const res = await ReplyService.ListAll(listRequest);
  if (res.code === 0) {
    replyList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error(res.msg);
  }
};

const resetSearch = () => {
  listRequest.current = 1;
  listRequest.size = 20;
  listRequest.content = "";
  listRequest.status = undefined;
  handleList();
};

onMounted(async () => {
  await handleList();
});

const handleSizeChange = (current: number, pageSize: number) => {
  listRequest.current = current;
  listRequest.size = pageSize;
  handleList();
};

const handleChange = (page: number, pageSize: number) => {
  listRequest.current = page;
  listRequest.size = pageSize;
  handleList();
};

const submitDelete = async (record: RechargeOrder) => {
  const res = await ReplyService.Delete(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDrop = async (record: RechargeOrder) => {
  const res = await ReplyService.Drop(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const columns: ColumnType[] = [
  {
    title: "Id",
    dataIndex: "id",
    align: "center",
  },
  {
    title: "用户OpenId",
    dataIndex: "user_open_id",
    align: "center",
  },
  {
    title: "快递编号",
    dataIndex: "delivery_number",
    align: "center",
  },
  {
    title: "邮寄方式",
    dataIndex: "mail_method_name",
    align: "center",
  },
  {
    title: "备注",
    dataIndex: "content",
    align: "center",
  },
  {
    title: "运输状态",
    dataIndex: "status",
    align: "center",
  },
  {
    title: "状态",
    dataIndex: "is_delete",
    align: "center",
  },
  {
    title: "创建时间",
    dataIndex: "create_at",
    align: "center",
  },
  {
    title: "更新时间",
    dataIndex: "update_at",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "operator",
    align: "center",
  },
];
</script>

<style scoped>
.container {
  border: 1px solid #d9d9d9;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 98%;
  margin-left: 1%;
  background-color: white;
  margin-top: 16px;
}

.form-item-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.label {
  white-space: nowrap;
}
</style>
